module.exports = __webpack_public_path__ + "img/ticket_btn.37e94e4f.png";